export default __webpack_public_path__ + "static/media/chopy_xl.c887d9bf.jpg";